// purchases accepts an array of invoices and returns an array of purchases
const purchases = (invoices) => {
    invoices = invoices || []
    return  invoices.map(inv => {
        //console.log('invoice:', inv);
        let status = inv.status;
        if (inv.amount === inv.amountRefunded) {
            status = "refund"
        } else if (inv.amountRefunded > 0){
            status = "part-refund"
        }

        return {
            id: inv.id,
            accountId: inv.account.id,
            amount: inv.amount,
            amountRefunded: inv.amountRefunded,
            date: inv.date,
            description: inv.description,
            receiptUrl: inv.receiptUrl,
            reference: inv.reference,
            skuId: inv.skuId,
            status: status,
        }
    })
}

export default purchases;